// https://scotch.io/tutorials/simple-language-translation-in-angular-2-part-2

// lang-pt.ts

// 'hello world': 'hello world',
// 'hello greet': 'Hello, %0 %1!',
// 'well done': 'Well done %0',
// 'good bye': 'bye bye',
export const LANG_PT_NAME = "pt";

export const LANG_PT_TRANS = {
  LblWeekdays: {
    shorthand: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
    longhand: [
      "Domingo",
      "Segunda-feira",
      "Terça-feira",
      "Quarta-feira",
      "Quinta-feira",
      "Sexta-feira",
      "Sábado"
    ]
  },
  LblMonths: {
    shorthand: [
      "Jan",
      "Fev",
      "Mar",
      "Apr",
      "Mai",
      "Jun",
      "Jul",
      "Ago",
      "Set",
      "Out",
      "Nov",
      "Dez"
    ],
    longhand: [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro"
    ]
  },
  LblButtonText: {
    today: "Hoje",
    month: "MÊS",
    week: "SEMANA",
    day: "Dia",
    list: "Lista"
  },

  // Common Name
  LblActivityLog: "Registo de atividade",
  LblEdit: "Editar",
  LblDelete: "Excluir",
  LblRemove: "Remover",
  LblActiveInactive: "Ativo/Inativo",
  LblActive: "Ativo",
  LblInactive: "Desativar",
  LblInactiveReason: "Razão de inativaçāo",
  LblAddNew: "Adicionar novo",
  LblAdd: "Adicionar",
  LblUpdate: "Atualizar",
  LblSave: "Salvar",
  LblCancel: "Anular",
  LblReset: "Reiniciar",
  LblSelect: "Selecionar",
  LblSuccess: "Sucesso",
  LblWarning: "Atenção",
  LblList: "Lista",
  LblAssign: "Atribuir",
  LblHome: "Pagina Inicial",
  LblYes: "Sim",
  LblOK: "Ok",
  LblNo: "Não",
  LblBack: "Retornar",
  LblReason: "Razão",
  LblRecordSavedSuccess: "Salvo com sucesso",
  LblRecordDeleteSuccess: "Excluido com sucesso",
  LblResetPasswordSuccess: "Senha redefinida com sucesso",
  LblConfirm: "Confirmar",
  LblBlockUnblockConfirm: "Tem a certeza que pretende passar de 1% para 0%?",
  LblRecordDeleteConfirmation: "Tem a certeza que pretende remover os 0%?",
  LblRecordMultiplDeleteConfirmation:
    "Tem a certeza que pretende remover os 0% selecionados?",
  LblConfirmMessage: "Você tem certeza?",
  LblResetPassword: "Redefinir senha",
  LblResetPasswordConfirmation:
    "Tem a certeza que pretende redefinir a sua senha?",
  LblGeoLocationError: "Insira a geolocalização correta",
  LblPersonDeleteCheck: "Excluir permanentemente",
  LblRejection: "Rejection",
  LblrejectionReasonMsg:
    "Please Provide Reason For rejection of selected booking requests",
  LblApproveConfirmationMsg:
    "Are You Sure you want to approve all selected booking request?",
  LblBookingCancelSuccess: "Reserva cancelada com sucesso",
  LblBookingApprovedSuccessMsg:
    "Pedidos de reservas selecionados aprovados com sucesso",
  LblBookingRejectedSuccessMsg:
    "Pedidos de reservas selecionados rejeitados com sucesso",
  LblBookingAbortSuccess: "Reserva interrompida com sucesso",
  LblBookingRevokeSuccess: "Reserva rescindida com sucesso",
  LblContactPersonRemoveSuccess: "Contato removido com sucesso",
  LblContactPersonAddedSuccess: "Contato adicionado com sucesso",
  LblNoRecords: "Registo não disponível",
  LblAffectedBookingList: "Lista com reservas afetadas",
  LblSubscriptionEndDateError: "Insira a data de término da subscrição",
  LblIsSpecialPeriodAllow:
    "Deseja solicitar o período de custo especial? Se aplicável",
  LblContractSlotisnotdefined:
    "O tipo de contrato não está definido para o período abaixo indicado",
  LblUnscubscribeSuccess: "subscrição cancelada com sucesso",
  LblModifiedBy: "Modificado por",
  LblModifiedDate: "Data de Modificação",
  LblContractTypeGroupAvailableForSubscription:
    "Não existe um grupo para o tipo de contrato para adicionar novo 0%",

  LblRemoveContactPersonConfirm:
    "Tem a certeza que pretende remover o contacto?",
  LblBookingApproveRejectSuccess: "%0 %1 com sucesso.",
  LblRecordAddedSuccess: "%0 added successfully.",
  LblRecordUpdatedSuccess: "%0 atualizado com sucesso.",
  LblRecordRemovedSuccess: "0% excluído com sucesso.",
  LblRecordActiveInActiveSuccess: "%0 %1 com sucesso.",
  LblinvoiceResendSuccess: "%0 enviado novamente com sucesso.",
  LblRecordBlokUnBlockSuccess: "%0 %1 com sucesso.",
  LblEditPage: "Editar %0",
  LblAddPage: "Adicionar %0",
  LblListPage: "%0 List",
  LblKilometers: "Quilómetro",
  LblKM: "Km",
  LblRecordUnBlockedSuccess: "%0 desbloqueado com sucesso",
  LblDeletePersonNote: "As faturas pendentes para essa pessoa não serão enviadas",

  //Instance Page
  LblWegoAdminDependencyValidation:
    "Administrador WeGo não pode ser removido por estar associado a outra entidade",
  LblCarwiseEnable: "Carwise Enabled",
  LblAdminDependencyValidationOnDelete:
    "Administrador selecionado não pode ser removido por estar associado a outra entidade",
  LblAdminDependencyValidation:
    "função de administrador não pode ser removido por estar associado a outra entidade",
  LblAdminDependencyAlert: "Pendente de validação do administrador",
  LblCarwiseConfiguration: 'Configuração "Carwise"',
  LblCarwiseConnectionUrl: "URL de ligação",
  LblCarwiseConnectionUsername: "Nome de utilizador de ligação",
  LblCarwiseConnectionPassword: "Senha de acesso de ligação",
  LblCarwiseAutoDeleteFrequencyInDays:
    "Eliminação periódica automática (Em dias)",
  LblInstance: "Instância",
  LblInstanceName: "Nome da instância",
  LblInstanceType: "Tipo de instância",
  LblDescription: "Descrição",
  LblCurrencySymbol: "Símbolo de moeda",
  LblPreferredLanguage: "Língua",
  LblTimeZone: "fuso horário",
  LblCurrencyAbbreviation: "Abreviação de moeda",
  LblInstanceDeleteValidation:
    "Não é possível excluir a instância por estar associada a outra entidade ",
  LblIsBookingApprovalReq: "É necessária aprovação da reserva",
  LblInstanceConfiguration: "Configuração de instância",
  LblBookingAlertTime: "Tempo de alerta de reserva",
  LblBookingCancelTime: "Tempo de cancelamento de reserva",
  LblBookingTemporaryTime: "Tempo de reserva provisório",
  LblVtsRequestTimeout: "Pedido do sistema de localização do veículo excedido",
  LblVtsTripLogTimeout:
    "Tempo de diário de viagem do sistema de localização do veículo excedido",
  LblEmailConfiguration: "Configuração de email (SMTP)",
  LblInSeconds: "Em segundos",
  LblFromEmail: "Do email",
  LblHost: "Convidado",
  LblPort: "Porta",
  LblEnableSsl: "Ativar SSL",
  LblSmtpEmail: "SMTP Email",
  LblBookingCancelTimeMessage:
    "Tempo (em segundos) após o qual não poderá cancelar a reserva.",
  LblBookingTemporaryTimeMessage:
    "Data para reserva provisória. O usuário já selecionou o veículo para a reserva mas ainda não confirmou.",
  LblVtSRequestTimeoutMessage:
    "Tempo esgotado para utilização do comando Abrir/Fechar na App",
  LblVtsTriplogTimeoutMessage:
    "Tempo esgotado para o cálculo da viagem após utilização do comando Fechar",
  LblContractTypeDeleteValidation:
    "Não é possível excluir o grupo do tipo de contrato porque está associado a outra entidade ",
  LblSelectFuelType: "Selecione tipo de combustível",
  LblSelectPricingCatagory: "Selecione categoria de preço",
  LblSelectBodyStyle: "Selecione o modelo",
  LblSelectVehicleClass: "Selecione classe de veículo",
  LblIsImportPersonAllow: "Permitir importar pessoa",

  LblValidateLicenseA2SP: "Validar carta de condução com A2SP",
  LblValidateLicense24IDCheck: "Validar carta de condução com 24ID",
  LblValidateLicenseForAllBookings: "Revalida carta de condução para todas as reservas",

  LblGeofenceLocation: "Perímetro de localização geográfica",
  LblRadius: "Raio",
  LblEmailRecepients: "Destinatários do e-mail",
  LblRecepients: "Destinatários",
  LblEmailAddresses: "E-mail",
  LblMap: "Mapa",

  // AFAS/Azure Config
  LblImportConfiguration: "Import Configuration",
  LblImportConnectionType: "Connection Type",
  LblAfas: "AFAS",
  LblAzure: "Azure",
  LblAzureTenantId: "Azure Tenant ID",
  LblAzureClientId: "Azure Client ID",
  LblAzureClientSecret: "Azure Client Secret",
  LblAfasClientId: "AFAS Client ID",
  LblAfasConnectorName: "AFAS Connector Name",
  LblAfasConnectionType: "AFAS Connection Type",
  LblAfasTest: "Test",
  LblAfasAccept: "Acceptation",
  LblAfasProduction: "Production",
  LblAfasToken: "AFAS Token",
  LblAfasClientIdError: "Please enter AFAS Client ID",
  LblAfasConnectorNameError: "Please enter AFAS Client ID",
  LblAfasConnectionTypeError: "Please enter AFAS Connection Type",
  LblAfasTokenError: "Please enter AFAS-Token",
  LblAzureTenantIdError: "Please enter Azure Tenant ID",
  LblAzureClientIdError: "Please enter Azure Client ID",
  LblAzureClientSecretError: "Please enter Azure Client Secret",

  // SSO Config
  LblSsoConfiguration: "SSO Configuration",
  LblDefaultSsoSharedVehicleGroup: "Default Shared Vehicle Group",
  LblDefaultSsoOrganization: "Default Organization",
  LblDefaultSsoSubscription: "Default Subscription",

  // Dropoff Message
  LblDropoffMessageConfiguration: "Dropoff Message Configuration",
  LblDropoffMessageExternalUrl: "External Url",
  LblDropoffMessageApiKey: "Api Key",
  LblDropoffMessageActive: "Active",
  
  LblValidate: "Validar",

  LblBookingCalanderSettings: "Configuração do calendário de reservas",
  LblShowDriverInfo:
    "Mostrar informações do condutor no calendário de reservas",
  LblOrganizationAdmin: "Administrador da organização",
  LblDriverInfoToShow: "Informação do condutor a apresentar",
  //Person Page
  LblUserName: "Usuário",
  LblFirstName: "Nome",
  LblLastName: "Sobrenome",
  LblEmail: "Email",
  LblMobileNumber: "Número de telemóvel",
  LblPhoneNumber: "Número de telefone fixo",
  LblHomeAddress: "Endereço de residência",
  LblWorkAddress: "Endereço profissional",
  LblHouseNo: "Número da residência",
  LblHouseExtention: "Andar",
  LblStreetName: "Rua",
  LblCity: "Cidade",
  LblZipCode: "Código Postal",
  LblPassword: "Senha",
  LblConfirmPassword: "Confirmar senha",
  LblMiddleName: "Nome do meio",
  LblMandateId: "ID do mandato",
  LblMandateSignatureDate: "Data da assinatura do mandato",
  LblIsAmmandment: "É uma emenda",
  LblRemovePersonDetails: "Excluir informação de utilizador",

  //Instance Clone
  LblInstanceClone: "Cópia da instância",
  LblNewInstanceName: "Nome da nova instância",
  LblCloneResult: "Clone Result",
  LblCloneStatus: "Clone Status",
  CloneError:
    "Ocorreu um erro ao copiar a instância e toda a sua informação",

  //Company Page
  LblCompany: "Empresa",
  LblCompanyName: "Nome da Empresa",
  LblContactPerson: "Pessoa de contato",
  LblCompanyAdmin: "Administrador da empresa",
  LblCompanyAddress: "Endereço da empresa",
  LblInternalOrganization: "Organização interna",
  LblNoOfVegicles: "Número de veículos",
  LblNoOfSharedVehicleGroups: "Número de grupos de veículos partilhados",
  LblGeoLocation: "Geolocalização",
  LblSelectGeoLocation: "Selecione localização",
  LblPerson: "Pessoa",
  LblRole: "Função",
  LblDateOfBirth: "Data de nascimento",
  LblDriverLicenceNumber: "Número da licença de condução",
  LblApkExiprationSetting:
    "Configurações de notificações da inspeção do veículo",
  LblApkTimeInterval: "período de tempo de notificação",
  LblEmailNotification: "Notificação por e-mail",
  LblNotificationFrequency: "Frequência de notificações",
  lblThresholdFrequency: "Limite de frequência",
  lblThresholdTimeInterval: "Limite do período de tempo",
  LblIsEmailEnabled: "Notificação de e-mail",
  lblThreshold: "Limite de período de tempo",
  LblFrequency: "Frequência",
  LblDay: "Dia",
  LblWeek: "SEMANA",
  LblMonth: "Mês",
  lblPerBooking: "Por reserva",
  LblPersons: "Pessoas",
  LblPersonOverview: "Resumo da pessoa",
  LblCompanies: "Empresas",
  //Vehicle Page
  LblVehicle: "Veículo",
  LblVtsVehicle: "sistema de localização do veículo",
  LblFleetId: "ID da frota",
  LblContractId: "ID do contato",
  LblVIN: "Número de chassis",
  LblLicenceTag: "Matrícula",
  LblLicence: "Licença",
  LblMobile: "Telemóvel",
  LblVehicleOwner: "Proprietário do veículo",
  LblLocationDataExchange: "Sincronização da informação de localização",
  LblBrand: "Marca",
  LblType: "Tipo",
  LblColor: "Cor",
  LblVehicleClass: "Classe de veículo",
  LblPricingCategory: "Categoria de preço",
  LblBodyStyle: "Carroçaria",
  LblAvailable: "Disponível",
  LblUnAvailable: "Não disponível",
  LblAvailableFrom: "Disponível a partir de",
  LblAvailableTo: "Disponível até",
  LblFuelType: "Tipo de combustível",
  LblMinBookingTimeBefore: "Tempo mínimo antes de reserva (minuto)",
  LblMinBookingTimeAfter: "Tempo mínimo após reserva (minuto)",
  LblTowbar: "Gancho de reboque",
  LblAirco: "Ar condicionado",
  LblVehicleAttributes: "Atributos de veículo",
  LblBlockUnBlock: "Bloquear/Desbloquear",
  LblRemoveLicense: "Excluir Carta de Condução",
  LblRemoveLicenseBirthDate:
    "Excluir Data Carta de condução e Data de Nascimento",
  LblLicenseBirthDate: "Data Carta de condução e Data de Nascimento",
  LblBlock: "Bloquear",
  LblUnblock: "Desbloquear",
  LblAvailableUnAvailable: "Disponível/Indisponível",
  LblVehicles: "Veículos",
  LblBookingsOverview: "Resumo das reservas",
  LblApkExpirationDateCet: "Data limite da inspeção do veículo",
  LblEnabled: "Ativar",
  LblDisabled: "Desativar",
  LblIntialOdometerValue: "Valor inicial do conta-quilómetros",
  LblFuelCardPinCode: "Código PIN do cartão de combustível",
  LblDropoffMessage: "Mensagem de entrega",
  LblPreferredlanguage: "Idioma preferido",
  LblDebtornr: "Número do devedor",


  LblFuel: "Fuel",
  LblVINnumber: "VIN number",
  LblVehicletype: "Vehicle type",
  LblDoors: "Number of doors",
  LblWeight: "Vehicle weight",
  LblTrunkSpace: "Trunk space",
  LblGears: "Number of gears",
  LblEngineHorsepower: "Engine horsepower (hp)",
  LblFuelConsumption: "Fuel consumption",
  LblSeats: "Number of seats",
  LblDimensions: "Vehicle dimensions",
  LblTransmissionType: "Transmission type",
  LblTransmissionUnknown: "Unknown",
  LblManualTransmission: "Manual",
  LblAutomaticTransmission: "Automatic",

  LblVehicleDetails: "Vehicle details",
  LblSelectVehicletype: "Select vehicle type",
  LblWrongVinNumber: "Wrong VIN number",

  //WEGO2DEV-325(Settings for Dashboard statuses)
  LblVehicleOnSameLocationTime: "Veículo na mesma localização mais do que",
  LblNoBookingIn: "Veículo sem reservas há mais de ",
  lblHour: "Hora",
  lblHourDayWeekMonth: "Hora / dia / semana / mês",

  //SharedVehicleGroup
  LblSharedVehicleGroup: "Grupo de veículos partilhados",
  LblVehicleGroup: "Grupo de veículo",
  LblSharedVehicleGroupAdmin: "Administrador de grupo de veículo partilhados",
  LblDisplayPeriod: "Exibir período",
  LblBookingWeekDays: "Dias disponivéis",
  LblBookingInterval: "Intervalo da reserva (minutos)",
  LblBookingStartTime: "Reserva a partir de (hh:mm)",
  LblBookingEndTime: "Reserva até (hh:mm)",
  LblBookingMinDuration: "Tempo mínimo da reserva (minutos)",
  LblBookingMaxDuration: "Tempo máximo da reserva (minutos)",
  LblMaxRecurringBooking: "Máximo de reservas recorrentes",
  LblPreBookingInterval: "Período pré-reserva (min)",
  LblPostBookingInterval: "Período pós-reserva (min)",
  LblBookingExtensionTime: "Tempo máximo de prolongamento (min)",
  LblBookAheadTime: "Reserva possível daqui a X min",
  LblBookingHorizon: "Horizonte da reserva",
  LblNumberOfContactTypeGroup: "Número de grupo de tipo de contrato",
  LblNumberOfContactType: "Número de tipos de contrato",
  LblInvoiceInterval: "Período de faturação",
  LblIsBookingIntervalAlignToCalendar:
    "Alinhamento do período de reserva no calendário",
  LblBookings: "Reservas",
  LblSharedVehicleGroups: "Grupos de veículos partilhados",
  LblSharedVehicleGroupOverview: "Resumo de grupos de veículos compartilhados",
  LblEarlyOpenInterval: "Intervalo de abertura adiantada (min)",

  //Driver
  LblDriver: "Motorista",
  LblLicenceNumber: "Número da carta de condução",
  LblDriverName: "Nome do condutor",
  LblDriverSVG: "Condutor do grupo de veículos partilhados",
  LblDriverUserName: "Nome de utilizador",

  //VehicleAttribute
  LblVehicleAttributeCategory: "Categoria de características do veículo",
  LblVehicleAttributeName: "Característica",
  LblVehicleAttributeDesc: "Descrição",
  LblVehicleAttribute: "Característica do veículo",
  LbAdditionallVehicleAttribute: "Additional Vehicle Attributes",
  LblVehicleAttributeCategories: "Categorias das características do veículo",

  //ContractType Page
  LblRegular: "Regular",
  LblWeekEnd: "Fim de semana",
  LblDayCT: "Dia",
  LblExtraTimeBefore: "Tempo extra antes (Minutos)",
  LblExtraTimeAfter: "Tempo extra depois (Minutos)",
  LblFreeTextDescription: "Especifique a taxa de reserva especial mais os horários de início e término (texto livre)",
  LblPeriodRate: "Período de tarifa",
  LblPeriodRateVat: "Período de tarifa",
  LblSelectContractTypeType: "Selecione tipo de tipo de contrato",
  LblContractTypeType: "Tipo de tipo de contrato",
  LblContractType: "Tipo de contrato",
  LblContractName: "Nome do contrato",
  LblContractTypeGroup: "Grupo de tipo de contrato",
  LblContractTypeGroupName: "Nome do grupo de tipo de contrato",
  LblContractAvailableDays: "Dias disponíveis do contrato",
  LblApplicableDays: "Dias aplicavéis",
  LblDayStartTime: "Início do horário (hh:mm)",
  LblDayEndTime: "Fim do horário (hh:mm)",
  LblApplicableStartTime: "Início do tempo aplicável (hh:mm)",
  LblApplicableEndTime: "Fim do tempo aplicável (hh:mm)",
  LblComment: "Observação",
  LblProcessingFee: "Taxa administrativa",
  LblVatPercentage: "percentagem de IVA",
  LblVatIncludedInPrice: "IVA incluído no preço",
  LblPlateformUsageCost: "Custo de utilização da plataforma",
  LblCatA: "Categoria A",
  LblCatB: "Categoria B",
  LblCatC: "Categoria C",
  LblCatD: "Categoria D",
  LblCatE: "Categoria E",
  LblCatF: "Categoria F",
  LblCatG: "Categoria G",
  LblCatH: "Categoria H",
  LblHourlyRate: "Preço por hora",
  LblMileageRate: "Valor por quilómetro",
  LblFixedFee: "Taxa fixa",
  LblPricingModel: "Modalidade de preço",
  LblContractStartDateTime: "Data/hora do início de contrato",
  LblContractEndDateTime: "Data/hora do fim de contrato",
  LblContractTypeHistory: "Histórico",
  LblContractTypPeriod: "Período do contrato tipo",
  LblInactiveContractTypeGroupReason:
    "Razão da desactivação do grupo de tipo de contrato",
  LblPenaltyAmount: "Valor da penalização",
  LblPenaltyTimeInterval: "período de tempo de penalização (minuto)",
  LblIsPenaltyEnabled: "Penalização ativada",
  LblTripDisplayType: "Como devem ser apresentadas as viagens nos relatórios?",
  LblAllTripsIndividually: "Por viagem, individualmente",
  LblAllTripsGrouped: "Agrupadas, todas as viagens numa só",

  // DateTime Picker
  LblJanuary: "Janeiro",
  LblFebruary: "Fevereiro",
  LblMarch: "Março",
  LblApril: "Abril",
  LblMay: "Maio",
  LblJune: "Junho",
  LblJuly: "Julho ",
  LblAugust: "Agosto",
  LblSeptember: "Setembro",
  LblOctober: "Outubro",
  LblNovember: "Novembro",
  LblDecember: "Dezembro",

  LblSJan: "Jan",
  LblSFeb: "Fev",
  LblSMar: "Mar",
  LblSApr: "Abr",
  LblSMay: "Mai",
  LblSJun: "Jun",
  LblSJul: "Jul",
  LblSAug: "Ago",
  LblSSep: "Set",
  LblSOct: "Out",
  LblSNov: "Nov",
  LblSDec: "Dez",

  LblSunday: "Domingo",
  LblMonday: "Segunda-feira",
  LblTuesday: "Terça-feira",
  LblWednesday: "Quarta-feira",
  LblThursday: "Quinta-feira",
  LblFriday: "Sexta-feira",
  LblSaturday: "Sábado",

  LblSSu: "Dom",
  LblSMo: "Seg",
  LblSTu: "Ter",
  LblSWe: "Qua",
  LblSTh: "Qui",
  LblSFr: "Sex",
  LblSSa: "Sáb",

  //Forgot Password
  LblForgotPassword: "Esqueci-me da senha",
  LblChangePassword: "Alterar senha",
  LblOldPassword: "Senha antiga",
  LblNewPassword: "Senha",
  LblProfileUpdatedSucessFully: "Perfil atualizado com sucesso",
  LblPasswordChangedSucessFully: "Senha alterada com sucesso",

  //
  LblUpdateProfile: "Atualizar perfil",
  LbLReasonVehicle: "Causa da indisponibilidade",
  LblReasonDriver: "Causa do bloqueio do condutor",

  //Booking
  LblFrom: "De",
  LblTo: "Até",
  LblBooking: "Reserva",
  LblApprovalAdminName: "Nome de administrador de aprovação",
  LblApprovedRejectedby: "Approved/Rejected by",
  LblBookingRequestList: "Booking Request List",
  LblBookingRequest: "Pedido de reserva",
  LblOverview: "Resumo de reserva",
  LblOverviewList: "Lista de reservas",
  LblApproveBooking: "Aprovação da reserva",
  LblApprove: "Aprovar",
  LblReject: "Recusar",
  LblNormal: "Reserva normal",
  LblSpecial: "Reserva especial",
  LblHistory: "História das reservas",
  LblBookingStatus: "Situação da reserva",
  LblBookingType: "Tipo de reserva",
  LblAdminRemarks: "Observação do administrador",
  LblBookingRemarks: "Observações da reserva",
  LblDriverRemarks: "Observação do condutor",
  LblBookingReferenceId: "Número da reserva",
  LblAbort: "Interromper",
  LblRevoke: "Rescindir",
  LblStatus: "Estado",
  LblReference: "Número da referência",
  LblRemarks: "Observações",
  LblSearchForVehicle: "Procura por veículo",
  LblVehicleOverview: "Resumo do veículo",
  LblConfirmBooking: "Confirmar reserva",
  LblCurrentBookingDetail: "Detalhes da reserva actual",
  LblCheckAvailability: "Verificar disponibilidade",
  LblBookingStartDateTime: "Início da reserva",
  LblBookingEndDateTime: "Fim da reserva",
  LblSource: "minha localização atual",
  LblRecurring: "Recorrente",
  LblRecurringId: "ID recorrente",
  LblRecurringBookingReference: "ID de reserva recorrente",
  LblDaily: "Diária",
  LblWeekly: "Semanal",
  LblMonthly: "Mensal",
  LblRecurrenceEndDate: "Repetiação da data final",
  LblSearch: "Procurar",
  LblBookNow: "Reservar agora",
  LblUpdateBooking: "Alterar reserva",
  LblEditCarNotAvailable: "Veículo original reservado não está disponível",
  LblSortBy: "Ordenar por",
  LblAvaibility: "Disponibilidade",
  LblDistance: "Distância",
  LblNoMatchingVehicle: "Não existe nenhum veículo correspondente",
  LblAvailableSlots: "Períodos disponíveis",
  LblFeatures: "Características",
  LblDriverDetail: "Dados do condutor",
  LblBookingDetail: "Dados da reserva",
  LblVehicleDetail: "Dados do veículo",
  LblBookingSuccess:
    "Pedido de reserva efetuada com sucesso. O seu pedido está pendente de validação. Será notificado quando a reserva for aceite.",
  LblBookingUpdateSuccess:
    "Reserva atualizada com sucesso. Notificação enviada para o e-mail do condutor.",
  LblBlockNormalBooking:
    "A sua conta encontra-se bloqueada. Entre em contacto com administrador de conta.",
  LblSingle: "Único",
  LblSeries: "Série",
  LblAll: "Todos",
  SelectionRequiredMsg: "Por favor selecione pelo menos um pedido para aprovar/rejeitar",
  LblSelectionRequired: "Selection Required",
  LblLicenceRequired1: "Por favor, verifique o número da sua licença, Ir para",
  LblLicenceRequired2: "Atualizar detalhes da licença",
  LblAcceptOrReject: "Aprovar/Rejeitar",

  //Special Booking
  LblSpecialBooking: "Reserva especial",
  LblAffectedBooking: "Reserva envolvida",
  LblSpecialBookingType: "Tipo de reserva especial",
  LblSelectSpecialBookingType: "Selecionar tipo de reserva especial",
  LblSpecialBookingConfiramtionmsg:
    "Tem a certeza que pretende criar uma reserva especial?",
  LblEndDate: "Data final da recorrência",

  // Notification
  LblNotification: "Notificação",
  LblSubject: "Assunto",
  LblDate: "Data",
  LblWelcomeNotification:
    "Bem-vindo à caixa de entrada de notificações da WeGo",

  //Template
  LblTemplate: "Modelo",
  LblTemplateList: "Lista de modelos",
  LblTemplateName: "Nome de modelos",
  LblTemplateType: "Tipo de modelos",
  LblBody: "Corpo",
  LblIsEmailTemplate: "E-mail",
  LblIsWebTemplate: "Rede",

  // Notification Event Management
  LblNotificationEventManagement: "Gestão de notificações de eventos",
  LblNotificationEvent: "Notificação do evento",
  LblModuleName: "Nome do módulo",
  LblSMS: "SMS",
  //User Type
  LblUserType: "Tipo de utilizador",

  //TimeBlock

  LblTimeBlock: "Período temporal",
  LblTimeBlockName: "Nome do período temporal",
  LblTimeBlockWeekDays: "Dias úteis do período temporal",
  LblTimeBlockStartDate: "Data de início do período temporal",
  LblTimeBlockStartTime: "Início do período temporal",
  LblTimeBlockEndDate: "Data de fim do período temporal",
  LblTimeBlockEndTime: "Fim do período temporal",

  // Service Offer
  LblServiceOffer: "Oferta de serviços",
  LblServiceOfferList: "Lista de oferta de serviços",
  LblServiceOfferName: "Nome do serviço",
  LblServiceOfferType: "Tipo de serviço",

  LblStandardTariff: "Tarifa padrão",
  LblTimeUsedOrBooked: "Tempo usado/reservado",
  LblPenalty: "Penalização",
  LblAdditional: "Extra",
  LblAdditionalAbbr: "Adicionar",
  LblUnit: "Unidade",

  //WegoAdminList
  LblWegoAdmin: "Administrador WeGo",
  LblWegoAdmins: "Administração WeGo",

  LblResend: "Reenviar",
  LblResendActivationMail: "E-mail de ativação",
  LblResendActivationMailFailure: "Falha no envio do e-mail de ativação",
  LblResendActivationMailSuccess: "E-mail de ativação enviado",

  //Subscription
  LblSubscription: "subscrição",
  LblSubscriptionName: "Nome da subscrição",
  LblTimeInterval: "Intervalo de tempo",
  LblAmount: "Montante",
  LblFreeKilometer: "Créditos livres",
  LblFreeMinute: "Minutos livres",
  LblFreeHours: "Horas livres",
  LblNumberOfSubscription: "Número de subscrições",
  LblUnsubscribe: "Cancelar subscrição",
  LblsubscribeEndDate: "Data de fim da subscrição",
  LblSubscriptionStartDate: "Data de início da subscrição",

  //Special Period
  LblSpecialPeriod: "Período especial",
  LblspecialPeriodName: "Nome do periodo especial",
  LblSpecialPeriodStartTime: "Início do período especial",
  LblSpecialPeriodEndTime: "Fim do período especial",
  LblSpecialPeriodWeekDays: "Dias úteis do período especial",
  LblNormalPeriod: "Período normal",
  LblSpecialPeriods: "Períodos especiais",

  //Booking InvoiceModel
  LblBookingInvoice: "Fatura de reserva",
  LblInvoiceStatus: "Situação da fatura",
  LblInvoiceType: "Tipo de fatura",
  LblSummary: "Resumo",
  LblTotalHours: "Horas totais",
  LblTotalKm: "Distância total (km)",
  LblTotalExpense: "Despesa total",
  LblInvoiceNumber: "Número da fatura",
  LblBegin: "Início",
  LblEnd: "Fim",
  LblVat: "IVA",
  LblDone: "Concluído",
  LblClear: "Remover",
  LblTotal: "Total",
  LblInvoiceRequestDateTime: "Data/Hora de requisição da fatura",
  LblInvoiceSendDateTime: "Data/Hora do envio da fatura",
  LblInvoiceDateTime: "Detalhes da fatura",
  LblInvoiceDetail: "Detalhes da fatura",
  LblReSend: "Reenviar",
  LblDownload: "Descarregar",
  LblResendInvoiceConfirm: "Tem a certeza do reenvio",
  LblPenaltyRate: "Taxa de penalização",
  LblInvoicing: "Faturar",
  LblInvoices: "data de vencimento",
  LblSendInvoiceConfirm: "Tem a certeza que deseja enviar a fatura?",

  LblProfile: "Perfil",
  LblSignOut: "Sair",
  LblTemplateNote1:
    "Por favor, não modifique nem elimine nenhum texto como { nome da variável }. Este é um atributo dinâmico que será substituído quando o e-mail for enviado para o utilizador.",
  LblTemplateNote2:
    "Por favor, não modifique a estrutura da tabela. Pode criar uma nova tabela. No entanto, a tabela original não deverá ser alterada.",
  LblTemplateNote3:
    'Por favor, certifique-se que depois de copiar o titular do lugar o cola no editor html através da opção "Colar como texto simples"',
  LblConfirmUnsubscribe: "Tem a certeza que deseja cancelar a sua subscrição?",
  LblDriveHours: "Horas de condução",
  LblVehicleImage: "Imagem do veículo",
  LblMaintenance: "Manutenção",
  LblUNAVAILABLE: "Não disponível",
  LblTestInvoiceGenerator: "Teste emissão de fatura",
  LblMissingInvoiceGenerator: "Gerador de faturas ausente",
  LblInvoicingDateTime: "Data/Hora da fatura (UTC)",
  LblGenerateInvoice: "Criar fatura",
  LblDeleteAllSelectedRecords: "Eliminar todos os arquivos selecionados",
  LblCancelAllSelectedRecords: "Cancelar todos os arquivos selecionados",
  "LblExportAll(CSV)": "Exportar todos (CSV)",
  LblAddContactPerson: "Adicionar contacto pessoal",
  LblRemoveContactPerson: "Remover contacto pessoal",
  LblNote: "Anotação",
  LblCompletelyEndConfirm: "Finalizar reserva",
  LblEndTrip: "Concluir a viagem",
  LblTestTrip: "Viagem de teste",
  LblTripSimulator: "Simulador de viagem",
  LblTestTripSuccess: "Viagem de teste criada com sucesso",
  LblDrivingStartDateTime: "Data/hora de início de viagem",
  LblDrivingEndDateTime: "Data/hora de fim de viagem",
  LblInvoiceMoment: "Momento de faturação",
  LblExtend: "Prolongar",
  LblExtendRequire:
    "Por favor, insira a duração (min) de prolongamento da reserva",
  LblExtendInfoMsg: "Poderá prolongar a reserva no máximo até % minutos",
  LblExtendValidationMsg: "Esta reserva não pode ser prolongada",
  LblExtendBooking: "Prolongamento da reserva",
  LblBookingExtendedSuccess: "Prolongamento da reserva bem sucedido",
  LblOverExtendValidationMsg:
    "Prolongamento da reserva não pode exceder % minutos",
  LblUnLock: "Desbloquear",
  LblLock: "Bloquear (Intermediário)",
  LblVehicleStatus: "Estado do veículo",
  LblTripSuccess: "Viagem guardada com sucesso",

  LblLockSuccessfully: "Veículo bloqueado com sucesso",
  LblLockCompletelySuccessfully: "Veículo completamente bloqueado com sucesso",
  LblUnLockSuccessfully: "Veículo desbloqueado com sucesso",
  LblUnlockProblem: "Problemas durante o comando de desbloqueio",
  LbllockProblem: "Problemas durante o comando de bloqueio",
  LblLockCarCompletely: "Bloquear e terminar reserva",
  LblStartDateTime: "Data/hora de inicío",
  LblEndDateTime: "Data/hora de fim ",
  LblBookingTripDetail: "Detalhes da reserva de viagem",
  LblAddNewTrip: "Adicionar nova viagem",
  LblBookingExpenseDetail: "Despesas detalhadas das reservas",
  LblUnlockErrorMessage:
    "Não existe grupo deste tipo de contrato disponível para criação da reserva",
  LblExpenseAmount: "Valor das despesas",
  LblExpenseName: "Nome das despesas",
  LblExpenseSuccess: "Despesas guardadas com sucesso",
  LblReceipt: "Recibo",
  LblHelpdeskNo: "Apoio ao cliente",
  LblBookingExpired:
    "Veículo não pode ser desbloqueado porque a reserva expirou",
  LblTripCalculationInProgress:
    "Esperamos que tenha tido uma óptima viagem! O veículo será bloqueado dentro de segundos.",

  LblVTSReqLogDetail:
    "Pedir detalhes do registo em sistema de localização do veículo",
  LblVTSReqDateTime: "Data/hora da requisição",
  LblVTSProcessTime: "Tempo de processamento",
  LblVTSResTime: "Tempo de resultado",
  LblVTSReqType: "Tipo de requisição",
  LblVTSResult: "Resultado",
  LblActualInvoiceGenerationDate: "Data da criação da fatura em vigor",
  LblAvailableForAllSlots: "Veículo disponível para todos períodos",
  LblUnAvailableSlots: "Períodos indisponíveis",
  LblNoOfDrivers: "Número de condutores",
  LblSVGDriversList: "Grupo de condutores de veículos partilhados",
  LblVehicleInformation: "Informação do veículo",
  LblVTSVehicle: "Sistema de localização do veículo",
  LblVTSVehicleUpdateSuccess: "Veículo atualizado com sucesso",
  LblVTSVehicleList: "Lista de veículos no sistema de localização do veículo",
  //Report Damage
  LblReportDamage: "Reportar dano",
  LblCompleteDamageReport: "Finalizar relatório de dano",
  LblDamageFile: "Arquivo de danos",
  LblDescribe: "Descreva o dano…",
  LblCause: "Descreva a causa do dano…",
  LblReportDamageMsg: "Dano reportado com sucesso",
  LblSelectFile: "Por favor selecione o arquivo",

  // Import Data
  LblCSVImport: "Importar CSV",
  LblValidateCSV: "Validar CSV",
  LblImportValidPerson: "Importar pessoa válida",
  LblImportValidDriver: "Importar condutor válido",
  LblImportValidVehicle: "Importar veículo válido",
  LblCSVType: "CSV Tipo",
  LblCSVFile: "CSV Arquivo",
  LblRecordImportedSuccess: "% importado com sucesso",
  LblInvalidReason: "Motivo inválido",
  LblSameVTSCommand: "Pedido está a ser processado. Por favor, aguarde.",
  LblImportPerson: "Importar pessoa",

  //Subscription related Changes
  LblSubscriptionInterval: "Período da subscrição",
  LblPaymentInterval: "Período de pagamento",
  LblInvoicInterval: "Período da fatura",
  LblInterval: "Período ",
  LblInvoiceMomentDay: "Momento da fatura (dia da semana)",
  LblInvoiceMomentMonth: "Momento da fatura (dia do mês)",
  LblFreeMinuteInterval: "Período de minutos livres",
  LblFreeKMInterval: "Período de quilómetros livres",
  LblSelectSubscriptionInterval: "Selecionar período de subscrição",
  LblSelectInvoiceInterval: "Selecionar período de fatura",
  LblSelectPaymentInterval: "Selecionar período de pagamento",
  LblSelectFreeKMInterval: "Selecionar período de quilómteros livres",
  LblSelectFreeMinInterval: "Selecionar período de minutos livres",
  LblYearlySub: "Anual",
  LblMonthlySub: "Mensal",
  LblWeeklySub: "Semanal",
  LblFreePerWeek: "Por semana",
  LblFreePerMonth: "Por mês",
  LblFreePerTriMonth: "Por trimestre",
  LblFreePerBiannual: "Por semestre",
  LblFreePerYear: "Por ano",
  LblDefaultContractTypeGroup: "Grupo padrão do tipo de contrato",
  LblSelectDefaultContractTypeGroup:
    "Selecionar grupo padrão do tipo de contrato",
  LblSendInvoiceToDriver: "Enviar fatura para o condutor",
  LblInherit: "Receber",

  //Invoice Moment
  LblDayOfMonth: "Dia do mês",
  LblDayOfWeek: "Dia da semana",
  LblSelectDayOfWeek: "Selecionar dia da semana",
  LblInstanceLogo: "Logotipo da instância",
  LblInvoiceDeleteValidation:
    "Fatura não pode ser removida por estar associada a outra entidade",

  //SubscriptionAvailabilityRestriction
  LblSubscriptionAvailabilityRestriction:
    "Restrição na disponibilidade da assinatura",
  LblStartDay: "Dia inicial",
  LblEndDay: "Dia final",
  LblStartTime: "Tempo inicial (hh:mm)",
  LblEndTime: "Tempo final (hh:mm)",
  LblRestriction: "Restrição",
  LblTotalFreeKilometer: "Total de quilómetros livres",
  LblTotalFreeMinute: "Total de minutos livres",
  LblCurRemainFreeKilometer: "Restantes quilómetros livres",
  LblPrevRemainFreeKilometer: "Restantes quilómetros livres anteriores",
  LblCurRemainFreeMinute: "Restantes minutos livres",
  LblPrevRemainFreeMinute: "Restantes minutos livres anteriores",
  LblResetPasswordFailure:
    "A senha não pode ser redefinida porque o utilizador ainda dão está ativo.",

  //Additional Free Item
  LblAdditionalFreeItems: "Créditos gratuitos adicionais",
  LblAdditionalFreeItemsMenu: "Créditos gratuitos adicionais",
  LblDateAwared: "Data selecionada",

  LblPrevious: "Anterior",
  LblCurrent: "Atual",

  LblTripDetailReport: "Relatório da viagem detalhado",
  LblTripDetailList: "Resumo detalhado das reservas",
  LblSearchTripforDriver: "Procurar reservas do condutor",
  LblExportReport: "Exportar relatório",
  LblValidateLiceanceNumberMessage:
    "Por favor, valide o número da sua carta de condução",
  LblBookingIntervalRate: "Taxa de período",
  LblPerHour: "Por hora",
  LblPerBookingIntarval: "Por período por reserva",
  LblTimeRate: "Taxa de tempo",
  LblToalBookingDuration: "Duração da reserva",

  LblTripComments: "LblTripComment",
  LblTripCommentDescription: "LblTripCommentDescription",
  LblTripCommentError: "LblTripCommentError",
  LblShowTripComment: "LblShowTripComment",
  LblAddTripComment: "LblAddTripComment",
  LblTripCommentBy:"LblTripCommentBy",
  LblTripCommentOn: "LblTripCommentOn",

  LblCleanRequire: "Limpeza necessária",
  LblFualRequire: "Combustível necessário",
  LblVehicleDamageList: "Lista dos danos do veículo",
  LblDamageCause: "Causa do dano",
  LblDamageReportedBy: "Reportado por",
  LblDamageReportedOn: "Reportado em",
  LblConfirmResolveDamage:
    "Tem a certeza que deseja remover o dano do veículo?",
  LblVehicleDamgeResolveSuccess: "Dano do veículo removido com sucesso",
  LblDamageDesc: "Descrição do dano",
  LblFutureBooking: "Reservas futuras",
  LblVehFutureBookingList: "Lista de reservas futuras do veículo",
  LblResolveDamge: "Remover dano",
  LblReserved: "Reservado",
  LblVehicleInfoSuccess: "Informação do veículo atualizada com sucesso",
  LblInformation: "Informação",
  LblVTSHistory: "Histórico dos eventos no sistema de localização do veículo",
  LblWegoRequestTime: "Data do pedido WeGo",
  LblVTSRequestTime: "Data do requisito do sistema de localização do veículo",
  LblRequestType: "Tipo de pedido",
  LblWegoProcessTime: "Data do processamento WeGo",
  LblResult: "Resultado",
  LblWegoResultTime: "Data do resultado WeGo",
  LblVTSResultTime: "Data do resultado do sistema de localização do veículo",
  LblCommandInitiator: "Comando Inicial",

  LblTroubleShootVTS:
    "Solução de problemas no sistema de localização do veículo",
  LblVtsServiceStatus: "Estado do serviço sistema de localização do veículo",
  LblVtsLicencetag: "Matrícula no sistema de localização do veículo",
  LblVtsDoorStatus: "Estado da porta",
  LblVtsIssueCommand: "Emitir comando",
  LblVehicleLocation: "Localização do veículo",
  LblEventHistory:
    "Histórico de ocorrências no sistema de localização do veículo",
  LblView: "Ver",
  LblVehicleObuStatus: "Estado da unidade de bordo do veículo ",
  LblVehicleNotInitialized: "Veículo não iniciado",
  LblLastReceivedTime: "Hora da última mensagem recebida",

  LblFreePerBookingInterval: "Por período por reserva",

  LblSelectFilter: "Selecionar filtro",
  LblAuditEntries: "Revisitar registos",
  LblFilter: "Filtro",
  LblCategory: "Categoria",
  LblEventName: "Nome do evento",
  LblEventData: "Informação do evento",
  LblMoment: "Momento",
  LblUser: "Utilizador",
  LblNoEventDataFound: "Não foram encontradas informações do evento",
  LblEventViewer: "Observador do evento",
  LblPrePostTripQuestions: "Pre and Post Trip Questions",
  LblPrePostTripQuestion: "Questão Pré e Pós viagem",
  LblPrePostTripQuestionList: "Pre and Post Trip Question List",
  LblPreTripQuestion: "Questões Pré-viagem",
  LblPostTripQuestion: "Post-trip questions",
  LblRequired: "Required",
  LblCustom: "Personalizar",
  LblBeforeOpeningTheVehicle: "Before opening the vehicle",
  LblAfterOpeningTheVehicle: "After opening the vehicle",
  LblOrder: "Order",
  LblQuestion: "Question",
  LblOn: "Sobre",
  LblOptional: "Opcional",
  LblOff: "Desligado",
  LblAnswerType: "Answer Type",
  LblText: "Text",
  LblYesNo: "Yes/No",
  LblAnswer: "Answer",
  LblTimeStamp: "Carimbo dia/hora",
  LblPrePostTripSetting: "Definições de questões Pré e Pós viagem",
  LblSelectObuType: "Selecionar tipo de unidade de bordo",
  LblFazTripQuestion: "Perguntas do FaZ",
  LblFazTripQuestionAfterClosingTheVehicle: "Perguntas FaZ após fechar o veículo",

  LblObuType: "Tipo de unidade de bordo",
  LblDeviceId: "ID do dispositivo",
  LblClaimCode: "Claim code",

  LblVtsLocation: "Localização no sistema de localização do veículo",
  LblRetriveAddress: "Recuperar o endereço",
  LblCrearedDate: "Data criada",
  LblCreatedBy: "Criado por",
  LblPerBooking: "Por reserva",
  LblOBU: "Unidade de bordo",
  LblClone: "Copiar",
  LblCloneVehicle: "Copiar %",
  LblFualNotRequire: "Combustível não necessário",
  LblCleanNotRequire: "Limpeza não necessária",
  LblSubscriptionInfo: "Informação da assinatura",
  LblVehiclDamaged: "Veículo danificado",
  LblVehicleNotDamaged: "Veículo sem danos",
  LblDamage: "Danificado",
  LblFreeBooking: "Ajustar custo da reserva",
  LblBookingCustomFee: "Customizar custo da reserva",
  LblFreeBookingSuccess: "Custo da reserva guardado com sucesso",
  LblEnterLocation: "Colocar localização",
  LblHomeLocation: "Localização da casa",
  LblLocationMode: "Modo localização",
  LblMeter: "Metro",
  LblLocation: "Localização",
  LblPickupLocation: "minha localização atual",
  LblLocationUnavailable: "Localização indisponível",
  LblAvailabilityCalander: "Calendário de disponibilidade",
  LblAvailableOn: "Disponível em",
  LblGeofenceEnabled: "Geofence ativada",
  LblLocationNotFound: "Não é possível determinar endereço no GPS",
  LblAddressNotAvailable:
    "Não é possível determinar a endereço nesta localização",
  LblReports: "Relatórios",
  LblDrivers: "Condutores",
  LblTemplates: "Modelos",
  LblVehicleOccupancyReport: "Relatório da ocupação do veículo",
  LblPlaceHolder: "Titular do lugar",
  LblSampleTemplate: "Ilustrativo do modelo",
  LblLatexFileDownloadValidation: "Conteúdo de látex inválido",
  LblLocationDataExchangeNotAssign:
    "Este veículo não pode ser reservado enquanto não for atribuído um sistema de localização do veículo. Deseja continuar o processo?",
  LblReservedTime: "Período de tempo reservado",
  LblUsageTime: "Período de tempo utilizado",
  LblUsageTimeAtOffice:
    "Período de tempo utilizado durante o horário de trabalho",
  LblUsageTimeoutOffice: "Uso fora de horário de expediente",
  LblRevenue: "Rendimento",
  LblRevenuePerVehicleReport: "Relatório de rendimento por veículo",
  LblSearchRevenuePerVehicle: "Pesquisar rendimento por veículo",
  LblRevenuePerVehicleList: "Rendimento por lista de veículos",

  //Dashboard
  LblInuse: "Em utilização",
  LblPriority: "Prioridade",
  LblDefaultStatus: "Estado padrão",

  //OdometerLogTrail
  LblOdometerLogTrail: "Histórico conta-quilómetros",
  LblUserProvidedOdometerValueInKmr: "Valor do conta-quilómetros (km)",
  LblDescriptionOfDeviation: "Descrição do desvio",
  LblFromOdometer: "Do conta-quilómetros",
  LblToOdometer: "To Odometer",
  LblAddDescriptionOfDeviation: "Adicionar descrição do desvio",
  LblDeviation: "Desvio (km)",
  LblLastOdometerValue: "Valor anterior de conta-quilómetros",
  LblLastOdometerDT: "Data anterior de conta-quilómetros",

  LblOdometerRegistered: "conta-quilómetros registado",
  LblOdometerValue: "Valor do conta-quilómetros",
  LblMaintenancePlanningList: "Lista dos planos de manutenção",
  LblSearchMaintenancePlanningValue: "Procurar plano de manutenção",
  LblMaintenancePlanningreport: "Relatórios dos planos de manutenção",

  LblodometerConfiguration: "Configuração do conta-quilómetros",
  LbLOdometerEnabled: "Conta-quilómetros ativado",
  LblEnableOnApp: "Ativar na App",
  LblWarningPer: "Aviso (%)",
  LblShowDeviation: "apresentar desvio que requere esclarecimento",

  LblTitle: "Título",
  LblFooterText: "Texto de rodapé",
  LblvalidEmailDomain:
    "Permitir apenas endereços de e-mail do seguinte domínio",
  LblURLSettings: "Configurações dos URL",
  LblSuccessUrl: "URL correto",
  LblEmailSettings: "Configuração de email",
  LblSendActivationEmail: "Ativar e-mails de ativação automáticos",
  LblSendConfirmationEmail: "Ativar e-mails de confirmação de inscrição",
  LblRequireAdminApprovel:
    "Exigir a aprovação do administrador a novas inscrições",
  LblDriverInformationToBeInclude:
    "Informação do condutor a ser incluída  no formulário (preenchimento obrigatório de todos os campos)",
  LblSignUpForm: "Formulário de inscrição",
  LblSignupForms: "Formulários de inscrição",
  LblSignupFormsOverview: "Resumo dos formulários de inscrição",
  LblWhoCanApprove: "Quem pode aprovar novas inscrições?",
  LblSignupFormLogo: "Logotipo do formulário de inscrição",
  LblChooseSubscription:
    "Escolha a(s) subscrição(s) disponíveis para o formulário de inscrição",
  LblSignupParameter: "URL de inscrição",
  LblSignupParameterText: "URL Texto de inscrição",
  DomainNameString:
    "Nome do domínio separado por vírgula (igual gmail.com,yahoo.com)",
  SignupParameterString:
    "São apenas permitidas letras de A a Z, números e hífen",

  LblAvailability: "Disponibilidade",
  LblSettings: "Configurações",
  LblCurrentStatus: "Estado atual",
  LblFlags: "Aviso",
  LblNA: "Não aplicável/Não disponível",

  //Sign up form
  LblConfirmEmail: "Confirmar e-mail",
  LblSignup: "Inscrever",

  LblSignupsOverView: "Resumo de inscrições",
  LblSignupApproval: "Aprovação da inscrição",
  LblAccept: "Aceitar",
  LblSignupFormDescription: "Descrição do formulário de inscrição",

  LblCurrentOdometerValue: "Valor atual do conta-quilómetros",
  LblCurrentOdometerDateTime: "Data/hora atual do conta-quilómetros",

  LblCreateDirectDebitFile: "Criar arquivo para débio direto",
  LblCheckEmptyIbanNumber: "Confirmar os números do IBAN",
  LblCreatedDate: "Data criada",
  LblIncludeInDirectDebit: "Incluir no arquivo de débito direto",
  LblDirectDebitFileDate: "Data do arquivo de débito direto",
  LblDirectDebitConfiguration: "Configuração de débito direto",
  LbLDirectDebitEnabled: "Ativar geração de arquivo de débito direto",
  LblDirectDebitEnableper: "Arquivo de débito direto ativado por",
  LbLCreditorDetails: "Informação do credor",
  LblAddress: "Endereço",
  LblIBANNumber: "Número de IBAN",
  LblCountryCode: "Código do país",
  LbLBillingInformation: "Dados de pagamento",
  LblFormat: "Formato",
  LblInvoicingDetails: "Dados da fatura",
  LbLSubjectToDirectDebit: "Sujeito a débito direto?",

  //Person Upload Batch
  LblBatchUploadPersonSetting:
    "Confirguação da importação de dados da pessoa em grupos",
  LblShowBatchUploadInfo: "Permitir importação de grupo de pessoas",
  LblAllowBatchUpload: "Permitir importação por",
  LblAllowActivationMail: "Use activation emails",
  LblGenerateRandomPassword: "Sistema gera senhas",
  LblUserUploadPassword: "Importar senhas",
  LblFieldToUploadedOrValidated: "Campos no arquivo importado",
  LblBatchUploadPerson: "Importar grupo de pessoas",
  LblBatchUpload: "Importar grupo de pessoas",
  LblImportDriverRole: "Atribuir papel do condutor automaticamente?",
  LblAssignToSVG: "Atribuir a grupo de veículos partilhados",
  LblSVG: "Grupo de veículos partilhados",
  LblDownloadTemplate: "Exemplo de arquivo importado",
  LblUserAssignSVGMessage:
    "Utilizador não atribuido a grupo de veículos partilhados",
  LblInvalidRecordReason: "Registo inválido",
  LblSelectedSVGs: "Grupo(s) de veículos compartilhados selecionado (s)",

  LblDashboard: "Painel",
  LblGroupAdmin: "Admin do grupo",
  LblDashboardConfiguration: "Configuração do painel",
  LblCurrentLocation: "Localização atual",
  LblEnableCurrentLocation: 'Ativar "localização atual"',
  LblDefaultLocation: "Localização padrão",
  LblEnableAutoUpdate: "Ativar atualização automática",
  LblPriorityNotificationSetting:
    "Configurações de notificações do estado do veículo",
  LblCollectionDate: "Data débito direto",
  LblBICCode: "Código BIC",
  LblDirectDebitFile: "Ficheiro débito direto",
  LblMissingIBANNumber: "IBAN incompleto",

  LblCurrentDriver: "Condutor atual",
  LblNextDriver: "Condutor seguinte",
  LblSecond: "Segundo(s)",

  LblCleaning: "Limpar",
  LblRefueling: "Reabastecer (de combustível)",
  LblAPKMaintenance: "Inspeção do veículo",
  LblOutsideGeofence: "Fora do perímetro de localização geográfica",
  LblNotBooked: "Sem reserva",
  LblNotBookedSince: "Sem reserva desde",
  LblLowBattery: "Bateria baixa",
  LblBatteryVolt: "Volt",
  LblLowCharge: "Carga baixa",
  LblChargingPercentage: "Carga %",
  LblOnSamePosition: "Na mesma posição",
  LblLastPosition: "Posição anterior",
  LblNotReturn: "Não entregue",
  LblCommunicationProblem: "Problema de comunicação",
  LblDirectDebitDownloadSuccess: "Ficheiro débito direto descarregado",
  LblWarnings: "Aviso",
  LblDirectDebitFileId: "ID do ficheiro débito direto",
  LblTotalAmount: "Valor total",
  LblReCreate: "Descarregar novamente",
  LblPleaseEnterCollectionDate: "Por favor introduzir data de débito direto",
  LblOpenViaLowLevel: "Abrir via urgente",
  LblInstanceNotificationNote1: "Repor definições de fábrica",
  LblNoInvoiceSelected: "Faturas não foram selecionadas para débito direto",
  LblIBANNumberRequired: "Por favor introduzir número de IBAN e código BIC",
  LblNoEmptyIBANFound: "IBAN não encontrado",
  LblInvalidTagUsed: "LblInvalidTagUsed",
  LblNotInvalidTagUsed: "LblNotInvalidTagUsed",
  
  LblShowVehicleChargeLevel:
    "Mostrar nível da carga do veículo na plataforma e na aplicação",
  LblChargeLevel: "Nível de carga",
  LblCharging: "Carregando",

  LblNoDataFound: "Dados não disponivéis",
  LblOfficeStartTime: "Início do horário de expediente (hh:mm)",
  LblOfficeEndTime: "Fim do horário de expediente (hh:mm)",

  //Reports
  LblTripDataReport: "Detalhes da viagem",
  LblByDriver: "Por condutor",
  LblByVehicle: "Por veículo",
  LblModuleRights: "Direitos do módulo",
  LblByOrganization: "Por empresa",

  //Organization
  LblOrganization: "Empresa",
  LblOrganizationName: "Nome da empresa",
  LblOrganizationAddress: "endereço da empresa",
  LblAddDriverSuccessMsg: "Condutor adicionado e link de ativação enviado com sucesso",
  LblExistingDriverAddSuccessMsg: "Condutor adicionado e associado à organização com sucesso",
  LblCreateOrganization: "Criar empresa",
  LblOrganizationDriversList: "Condutor da organização",
  LblAddDriver: "Adicionar condutor",
  // Branding
  LblBranding: "Marca",
  LblLogo: "Logotipo",
  LblEmailNotificationInvoiceTemplate: "Notificação de email & modelo de fatura",
  LblExpandedWebMenu: "Menu da plataforma expandido",
  LblCollapsedWebMenu: "Menu da plataforma escondido",
  LblMobileApp: "Aplicação móvel",
  LblSplashScreen: "Ecrãn incial",
  LblWebApplication: "Plataforma",
  LblMobileApplication: "Aplicação móvel",
  LblBrandingSavedSuccess: "Marca guardada com sucesso",
  LblBrandingTemplateConfiguration: "Configuração de branding & modelo",
  LblAppWebUI: "Aplicação & plataforma",
  LblNonBookingCommunication: "Comunicação geral",
  LblBookingCommunication: "Comunicação relacionada com a reserva",
  LblInstanceBranding: "Usar sempre a marca da instância",
  LblCompanyBranding: "Usar o branding da empresa sempre que possível",

  BO_TOP_MENU_ACTIVE_ITEM_BACKGROUND: "Barra superior, menu e itens ativos",
  BO_TOP_MENU_ACTIVE_ITEM_TEXT: "Texto do menu",
  BO_HIGHLIGHTED_BUTTON_BACKGROUND: "Botão destacado",
  BO_HIGHLIGHTED_BUTTON_TEXT: "Botão de texto destacado",
  BO_HIGHLIGHTED_BUTTON_BACKGROUND_HOVER: "Botão destacado (suspenso)",
  BO_HIGHLIGHTED_BUTTON_TEXT_HOVER: "Botão de texto destacado (suspenso)",
  BO_PRIMARY_BUTTON_BACKGROUND: "Botão principal",
  BO_PRIMARY_BUTTON_TEXT: "Botão de texto principal",
  BO_PRIMARY_BUTTON_BACKGROUND_HOVER: "Botão principal (suspenso)",
  BO_PRIMARY_BUTTON_TEXT_HOVER: "Botão de texto principal (suspenso)",
  BO_SECONDARY_BUTTON_BACKGROUND: "Botão secundário",
  BO_SECONDARY_BUTTON_TEXT: "Botão de texto secundário",
  BO_SECONDARY_BUTTON_BACKGROUND_HOVER: "Botão secundário (suspenso)",
  BO_SECONDARY_BUTTON_TEXT_HOVER: "Botão de texto secundário (suspenso)",
  BO_HYPERLINK_TEXT: "ligação de texto",
  BO_HIGHLIGHT_BACKGROUND: "Cor de destaque",
  BO_HIGHLIGHT_TEXT: "Texto de destaque",

  BO_CALENDAR_EVENT_BACKGROUND: "Reservas no calendário",
  BO_CALENDAR_EVENT_TEXT: "texto de reservas no calendário",

  MO_CALENDAR_EVENT_BACKGROUND: "Reservas no calendário",
  MO_CALENDAR_EVENT_TEXT: "texto de reservas no calendário",
  MO_DISABLED_BUTTON_BACKGROUND: "Botão desativado",
  MO_DISABLED_BUTTON_BACKGROUND_ACTIVE: "Botão desativado (ativo)",
  MO_DISABLED_BUTTON_TEXT: "botão de texto desativado",
  MO_DISABLED_BUTTON_TEXT_ACTIVE: "botão de texto desativado (ativo)",
  MO_ENABLED_BUTTON_BACKGROUND: "Botão ativado",
  MO_ENABLED_BUTTON_BACKGROUND_ACTIVE: "Botão ativado (ativo)",
  MO_ENABLED_BUTTON_TEXT: "Botão de texto ativado",
  MO_ENABLED_BUTTON_TEXT_ACTIVE: "Botão de texto ativado (ativo)",
  MO_HIGHLIGHT_BACKGROUND: "Cor de destaque",
  MO_HIGHLIGHT_TEXT: "Texto de destaque",
  MO_HYPERLINK_TEXT: "ligação de texto",
  MO_LOGO_AREA_BACKGROUND: "Fundo do logotipo",
  MO_MENU_TEXT: "Texto de menu",
  MO_PAGE_BACKGROUND: "Fundo ",
  MO_TITLE_TEXT: "Texto do título",
  MO_TOP_MENU_ACTIVE_ITEM_BACKGROUND: "Barra superior e menu ",

  LblBookingDelayConfig: "Configuração de atraso da reserva",
  LblBookingDelayConfigEnabled: "Enviar email para administrador",
  LblEnableSnauilTrail: "Ativar registo de trajecto",
  LblAppSupportTo: "Apoio para",
  LblNotificationInterval: "Intervalo de notificação",
  LblNotifyAfterMinutes: 'Notificar depois de "X" minutos',
  LblMinutesAfterBookingEndTime:
    "Quantos minutos após o fim de reserva deve ser enviada a notificação?",
  LblResendNotoficationEvery: 'Reenviar a notificação a cada "X" minuto(s)',
  LblMinutes: "Minutos",
  lblNotificationRecipients: "Destinatários da notificação",
  LbLEnableBookingStillRunning: "Ativar notificação de reserva a decorrer",
  LblBookingrunningNotification:
    "Configuração da notificação de reserva a decorrer",
  LblPreferableImageSize: "Resolução de imagem",
  LblWebBrandingExapandImageSize: "1150px X 260px",
  LblMobileBrandingImageSize: "550px X 250px",
  LblWebBrandingCollapseImageSize: "325px X 250px",

  //MobileApp Configuration
  LblMobileAppConfiguration: "Configurações da aplicação",
  LblEnableNewBooking: "ativar nova reserva",
  LblEnableBookingCalender: "ativar calendário de reservas",
  LblEnableSubscription: "ativar subscrição",
  LblEnableUpdateProfile: "ativar atualização de perfil",
  LblEnableNotification: "ativar notificações",
  LblEnableChangeBooking: "ativar alteração de reservas",
  LblEnableAddExpenseMenu: "ativar menu de adicionar despesas",

  //Raise and clear settings for low battery flag
  LblDefaultVehicleSetting: "Definições padrão do veículo",
  LblLowBatteryFlagRaised: "Aviso de bateria fraca na (voltagem) ",
  LblLowBatteryFlagClear: "Aviso de bateria fraca removido na (voltagem) ",
  LblByBooking: "Na reserva",
  LblSnailTrailReport: "Relatório de trajecto",
  LblKickbackReport: "Relatório kickback",
  LblGroupBy: "Agrupar por",
  LblTripDetail: "Detalhe de viagem",
  LblTripNumber: "Número de viagem",
  LblStart: "Início",
  LblAverageSpeed: "Velocidade média",
  LblSegmentDetail: "Detalhe de segmento?",
  LblSegmentNumber: "Número de segmento",
  LblSpeed: "Velocidade",
  LblOdometer: "Velocímetro",
  LblNext: "Próximo",
  LblSegmentDetailNotAvailable: "Detalhe de segmento não disponível",
  LblUnitPerKm: "por quilómetro",
  LblUnitPerBooking: "Por reserva",

  LblBookingCostSummary: "Resumo de custo de reserva",
  LblTimeCost: "Custo de tempo",
  LblTotalTime: "Tempo total",
  LblTime: "Tempo",
  LblFreeTime: "Tempo livre",
  LblRate: "Taxa",
  LblExVat: "Sem IVA",
  LblInclVat: "IVA incluído",
  LblKmDriven: "Quilómetros conduzidos",
  LblFreeKms: "Quilómetros disponíveis",
  LblTimePercent: "Percentagem de tempo",
  LblTotalExVat: "Total sem IVA",
  LblTotalVat: "Total IVA",
  LblTotalInclVat: "Total IVA incluído",
  LblKilometerCost: "Custo do quilómetro",
  LblFixedCost: "Custo fixo",
  LblTotals: "Totais",
  LblTypeDamage: "Dano",
  LblTypeMaintenance: "Manuntenção da inspeção veícular previsto",
  LblTypeOnSamePosition: "Veículo na mesma localização mais do que  %0 %1",
  LblTypeNotBooked: "Veículo sem reservas há mais de %0%1",
  LblTypeNotReturn: "Tempo de reserva expirado e veículo não devolvido",
  LblBatteryVoltage: "Voltagem da bateria",

  LblCannotUnsubscribe: "Não é possível cancelar a reserva, uma vez iniciada",
  LblPer: "Por",

  LblDateRegistered: "Data de registo",
  LblRegisteredBy: "Registado por",
  LblKMPerHour: "Km/h",
  LblMeters: "Metros",
  LblSubscriptionEndOnBookingEnd:
    "Reserva a decorrer. O utilizador passará a ser inválido após esta reserva.",
  LblMarkedForDeletion: "Marcado para exclusão",
  LblApplyDateFilter: "Aplicar data",

  LblNoRestriction: "SEM RESTRIÇÕES",
  LblCustomAppTestApp: "PERSONALIZAR_APLICAÇÃO_E_TESTAR_APLICAÇÃO",
  LblCustomAppOnly: "PERSONALIZAR_SÓ_APLICAÇÃO",

  //Customer
  LblCustomer: "Cliente",
  LblCustomerName: "Nome do cliente",

  //Role Page
  LblRoleManagement: "Função",
  LblRoleName: "Nome da função",
  LblEntityName: "Nome da empresa",
  LblRoleType: "Tipo de função",
  LblRoleAvailability: "Disponibilidade função do cliente",
  LblInternalRoleName: "Nome interno da função",
  LblPresentationName: "Nome de apresentação",
  LblDefaultRole: "Função padrão",
  LblCustomRole: "Personalizar função",
  LblAddRole: "Adiconar função",
  LblEntity: "Empresa",
  LblCopy: "Copiar",
  LblAccessibilityMatrix: "Matriz de acesso",
  LblDefaultRoleModifyWarning:
    "A alteração das permissões padrão irá afetar todos os utilizadores que usem a função padrão.",
  LblCopyAccessibilityMatrix: "Copiar matrix de acessos",
  LblAccess: "Acesso",
  LblCustomerAdmin: "Administrador do cliente",
  LblAdmin: "Administrador",
  LblDoYouWantToRemove: "Pretende remover %0 para %1?",
  LblDoYouWantToAdd: "Pretende passar de %0 para %1?",
  LblRoleAddedSuccess: "%0 adicionado com sucesso",
  LblRoleDeletedSuccess: "%0 removido com sucesso",
  LblInstanceAdmin: "administrador de instância",
  LblInvitationMailSuccess:
    "convite rejeitado",
  LblInvite: "Enviar convite",
  LblCreateNew: "Criar novo",
  LblCommonErrorMessage:
    "Ocorreu um erro durante o processamento do pedido. Por favor contacte o adminstrador",
  LblError: "Erro",
  LblThankYouForAcceptingInvitation: "Obrigado(a) por aceitar o convite",
  LblPleaseClick: "Por favor selecione",
  LblHere: "aqui",
  LblToLogin: "para entrar",
  LblThankYouForConfirmation: "Obrigado(a) pela sua confirmação",
  LblGoToHome: "Ir para páginal inicial",
  LblInvitationSuccess: "Enviar convite",
  LblInvitationReject: "convite rejeitado",

  //
  LblAssignExisting: "Atribuição existente",
  LblPersonProfileSuccessMessage: "O seu perfil foi ativado com sucesso",
  LblPlease: "Por favor",
  LblLogin: "Entrar",

  //Organization
  LblVatNumber: "Número de iva",

  //Branding & Template
  LblBrandingandTemplates: "Branding & Templates",
  LblTermsAndCondition: "Termos e Condições",
  LblTermsAndConditionList: "Termos e Condições & Privacidade",
  LblName: "Nome",
  LblVersion: "Versão",
  LblAcceptance1: "Antes da ativação da conta",
  LblAcceptanceMoment: "Momento de aceitação",
  LblContents: "Conteúdo",
  LblIsAccept: "Aceito",
  LblReadAndAgree: "Li e aceito",
  LblClose: "Fechar",
  LblTermsConditionPrivacy: "Termos e Condições & Privacidade",
  LblPrivacyStatements: "Termos de Privacidade",
  LblDamageImageExtentions: "Extensão da imagem do Dano",

  //Accessibility Matrix
  LG_WEB_DASHBOARD: "Painel de controlo de rede",
  PR_BOOKING_REQUEST: "Booking Request",
  LblApproveBookingRequest: "Aprovar",
  LblRejectBookingRequest: "Rejeitar",
  PR_INVOICE_PAYMENT_HISTORY: "Histórico de pagamentos de faturas",
  PR_TERMS_AND_CONDITION: "Termos e Condições",

  PR_PRE_POST_TRIP_QUESTIONS: "Resumo Questões Pré e Pós viagem",

  PR_ADDITIONAL_FREE_ITEMS: "Adicionar items gratuitos",
  PR_BATCH_UPLOAD_PERSON: "Importar lote de pessoas",
  PR_BOOKINGS_OVERVIEW: "Resumo de reservas",
  PR_BRANDING: "Marca",
  PR_COMPANY_ADMIN: "Adminstrador da empresa",
  PR_COMPANY_OVERVIEW: "Resumo da empresa",
  PR_COMPANY_SVG_OVERVIEW:
    "Resumo de grupos de veículos partilhados da empresa",
  PR_COMPANY_VEHICLE_OVERVIEW: "Resumo veículos da empresa",
  PR_CONTACT_PERSON: "Contacto da pessoa",
  PR_CUSTOMER_ADMIN_OVERVIEW: "Resumo administrador do cliente",
  PR_CUSTOMER_OVERVIEW: "Cliente",
  PR_DASHBOARD: "Painel de controlo",
  PR_REMOVE_DRIVER_LICENSE: "Remove Driver License",
  PR_DIRECT_DEBIT_FILE: "Ficheiro débito directo",
  PR_DRIVER_OVERVIEW: "Resumo do condutor",
  PR_DRIVER_SHARED_VEHICLE_GROUP_OVERVIEW:
    "Resumo do grupo de veículos partilhados do condutor",
  PR_DRIVER_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW:
    "Resumo da subscrição de grupo de veículos partilhados do condutor",
  PR_EVENT_VIEWER: "Visualizar evento",
  PR_PRE_POST_TRIP_SETTING: "Definições Questões Pré e Pós viagem",
  PR_IMPORT_PERSON: "importar pessoa",
  PR_PRE_POST_TRIP_QUESTION_UPDATE: "Questões Pré e Pós viagem",
  PR_INSTANCE: "instância",
  PR_INSTANCE_ADMIN_OVERVIEW: "Resumo administrador de instância",
  PR_INVOICE: "Fatura",
  PR_KICKBACK_REPORT: "Relatório kickback",
  PR_MAINTENANCE_PLANNING_REPORT: "Relatório de planeamento de manutenções",
  PR_NORMAL_BOOKING: "Reserva normal",
  PR_ODOMETER_LOG_TRAIL: "Registo conta-quilómetros",
  PR_ODOMETER_LOG_TRAIL_REGISTERED_BY: "Registo conta-quilómetros criado por",
  PR_ORGANIZATION_ADMIN_OVERVIEW: "Resumo administrador da empresa",
  PR_ORGANIZATION_CONTACT_PERSON: "Pessoa de contacto da empresa",
  PR_ORGANIZATION_DRIVER_OVERVIEW: "Resumo de condutor da empresa",
  PR_ORGANIZATION_OVERVIEW: "Resumo da empresa",
  PR_ORGANIZATION_SUBSCRIPTION_OVERVIEW: "Subscrição da empresa",
  PR_PERSON_OVERVIEW: "Resumo pessoa",
  PR_REVENUE_PER_VEHICLE_REPORT: "Relatório de rendimentos por veículo",
  PR_ROLE_ASSIGN: "Função atribuida",
  PR_ROLE_OVERVIEW: "Função",
  PR_SANIL_TRAIL_REPORT: "relatório snail trail",
  PR_SHARED_VEHICLE_GROUP_ACTIVE_INACTIVE:
    "Grupo de veículos partilhados ativo ou inativo",
  PR_SHARED_VEHICLE_GROUP_ADMIN_OVERVIEW:
    "Resumo Grupo de veículos partilhados do administrador",
  PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_GROUP_OVERVIEW:
    "Resumo do Grupo de Tipo de contratos do Grupo de veículos partilhados",
  PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_OVERVIEW:
    "Resumo de tipo de contrato de grupo de veículos partilhados",
  PR_SHARED_VEHICLE_GROUP_DRIVER_OVERVIEW:
    "Resumo de grupo de veículos partilhados do condutor",
  PR_SHARED_VEHICLE_GROUP_OVERVIEW: "Resumo Grupo de veículos partilhados",
  PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_AVAILIBILTY_RESTRICTION_OVERVIEW:
    "Resumo de restrições de disponibilidades de grupos de veículos partilhados",
  PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW:
    "Resumo de subscrições de grupos de veículos partilhados",
  PR_SHARED_VEHICLE_GROUP_VEHICLE_OVERVIEW:
    "Resumo de veículos de grupos de veículos partilhados",
  PR_SIGNUP_FORMS_OVERVIEW: "Resumo de formulário de inscrição",
  PR_SIGNUP_OVERVIEW_TO_SHARED_VEHICLE_GROUP:
    "Resumo de inscrições de grupos de veículos partilhados",
  PR_SIGNUP_OVERVIEW_TO_SIGNUP_FORM: "Resumo de formulário de inscrição",
  PR_SIGNUPS_OVERVIEW: "Resumo de inscrições",
  PR_SPECIAL_BOOKING: "reserva especial",
  PR_SPECIAL_PERIODS: "Períodos especiais",
  PR_TEMPLATES: "Modelos",
  PR_TEST_INVOICE_GENERATOR: "Teste de emissão de faturas",
  PR_TRIP_DATA_REPORT: "detalhes da viagem",
  PR_TRIP_SIMULATOR: "simulador de viagem",
  PR_USER_PROFILE: "perfil de utilizador",
  PR_VEHICLE_ATTRIBUTE: "Características do veículo",
  PR_VEHICLE_ATTRIBUTE_CATEGORIES: "Categoria de características do veículo",
  PR_VEHICLE_FUTURE_BOOKINGS: "Futuras reservas do veículo",
  PR_VEHICLE_OCCUPANCY_REPORT: "Relatório de ocupação do veículo",
  PR_VEHICLE_SVG_OVERVIEW:
    "Resumo de veículos de grupos de veículos partilhados",
  PR_VEHICLES_OVERVIEW: "Resumo de veículos",
  PR_VTS_TROUBLESHOOT:
    "Resolução de problema para o sistema de localização do veículo",
  PR_VTS_VEHICLE_EVENT_HISTORY:
    "Histórico do sistema de localização do veículo",
  PR_VTS_VEHICLE_LIST: "Lista de veículos no sistema de localização do veículo",
  PR_WEGO_ADMINS: "Administrador WeGo",
  PR_PREPOST_TRIP_QUESTIONS_UPDATE: "Questões Pré e Pós viagem",

  LG_CUSTOMER: "Cliente",
  LG_INSTANCE: "instância",
  LG_BRANDING: "Marca",
  LG_PERSON: "Pessoa",
  LG_COMPANY: "Empresa",
  LG_ORGANIZATION: "Empresa",
  LG_SHARED_VEHICLE_GROUP: "Grupo de veículos partilhados",
  LG_VEHICLE: "Veículo",
  LG_DRIVER: "Condutor",
  LG_BOOKING: "Reserva",
  LG_INVOICE: "Fatura",
  LG_REPORT: "Relatório",
  LG_TEMPLATE: "Modelo",
  LG_SIGNUP_FORM: "Formulário de inscrição",
  LG_EVENT_VIEWER: "Visualizar evento",
  LG_PRE_POST_TRIP_SETTING: "Definições Questões Pré e Pós viagem",
  LG_USER: "utilizador",
  LG_BRANDING_AND_TEMPLATE: "Branding & Templates",
  LG_ROLE: "Função",
  LG_PREPOSTTRIPQUESTION: "Questões Pré e Pós viagem",

  LG_REPORTINGTOOL: "Reporting Tool",
  PR_BOOKING_OVERVIEW: "Booking overview",
  PR_ROB_NOTIFICATIONS: "ROB overview",
  PR_MILEAGE_OVERVIEW: "Mileage overview",
  PR_USAGE_OVERVIEW: "Number of days not used",
  PR_POSITION_ON_MAP: "Position on the map",
  PR_VEHICLE_ON_LOCATION_MAP: "Vehicle on location",
  PR_TRIP_OVERVIEW: "Trip registration",
  PR_ALTERNATE_TRANSPORTATION: "Alternate transportation",
  PR_AVERAGE_OVERVIEW: "Averages overview",
  PR_PRE_POST_BOOKING_OVERVIEW: "Pre/post questions per booking overview",
  PR_HOME_LOCATIONS_OVERVIEW: "Vehicle and SVG home locations overview",


  LblPrivacyErrorMessage: "Quem não está autorizado a ver esta página?",
  LblPrivacyNavigate: "Por favor vá para a página",
  LblPrivacyError: "Erro de privacidade",
  LblLinkExpired: "Ligação expirada",
  LblLinkExpiredMessage:
    "O link está expirado e não pode mais ser usado. Por favor, tente novamente.",
  LblBearer: "Barreira",
  LblWhoBenifitFreeItem: "Quem beneficia dos créditos de subscrição?",
  LblNoDistinction: "Padrão",
  LblSendInvoiceToOrganization: "Enviar fatura para a empresa",

  //Vat Setting
  LblVatSettings: "Definições de iva",
  LblVatPercentages: "Percentagem de iva",
  LblDefaultCost: "Mostrar e editar custos, por defeito",
  LblExcludingVat: "Sem iva",
  LblIncludingVat: "iva incluído",
  LblVatEnterDescription: "Introduzir descrição",
  LblEnterVatPercentage: "introduzir percentagem de iva",
  LblVatPercentageError: "Por favor introduza uma percentagem válida",
  LblVatDescriptionError: "Por favor introduza uma descrição válida",
  LblVatStartDate: "Data de inicio",
  LblVatStartDateError: "Por favor selecione a data de inicio",
  LblStartDate: "Data de inicio",
  LblVatEndDate: "data final",
  LblVatDeleteConfirmation:
    "Tem a certeza que pretende defenir data de fim para o IVA?",
  LblVatEndDateError: "Por favor introduza data final de IVA",
  LblVatEndDateNote: "Nota: a informação excluida para a data selecionada",
  LblDefaultVatContractTypeGroupCost:
    "% IVA para custos com grupos de tipo de contrato",
  LblDefaultVatContractTypeCost: "% IVA para custos com o tipo de contrato",
  LblDefaultVatSubscriptionCost: "% IVA para custos com subscrições",
  LblPenaltyCost: "Valor de penalização",
  LblTimeRates: "taxa de tempo",
  LblDistanceRates: "Taxas de distância",
  LblFixedRates: "Taxa fixa",
  LblSubscriptionCost: "Valor de subscrição",

  LblPenaltyVat: "percentagem de iva da penalização",
  LblTimeRateVat: "Percentagem de iva do tempo",
  LblMileageRateVat: "Percentagem de iva para quilometragem",
  LblFixedFeeVat: "Taxa fixa de iva",
  LblExpenseAmountVat: "Valor de iva",

  // template
  LblEmailTemplate: "Modelo de e-mail",
  LblWebTemplate: "Modelo de rede",
  LblEmailAddressesEntryPattern:
    "Separar e-mail por virgulas (ex1@ex.com, ex2@ex.com)",
  LblNoRecipientWarning:
    "Sem destinatário atríbuido. O modelo será enviado para os destinatários padrão.",
  LblCostAndExpenses: "Custos e despesas",
  LblSender: "Sender",
  LblAddressee: "Inativo após (dias)",
  LblAddLine: "Apagar após (dias)",
  LblSaveInvoice: "Save Invoice",
  LblVatAmount: "Definições de Política de proteção de dados",
  LblBookingId: "Data de exclusão",
  LblReceiptOrSuppor: "Excluir utilizador a",
  LblVATPercentage: "Histórico de pagamentos de faturas",
  LblChargeTo: "Método de pagamento",
  LblReimburseTo: "Hora de registo",
  LblReportedBy: "Link de pagamento não foi gerado",
  LblReportedAmount: "Permitir configuração de pagamento",
  LblApprovedAmount: "Autorizar pagamento",
  LblCostType: "Configuração pagamento a fornecedor",
  LblRecipient: "Ambiente",
  LblCostDetail: "Histórico de pagamentos",
  LblCostCenterReport: "Validade da ligação (dias)",
  LblShowTotalOnly: "Método de pagamento",
  LblChamberOfCommerce: "Senha de acesso do fornecedor",
  LblInvoicingSettings: "Invoicing Settings",
  LblInvoiceSender: "link para pagamento",

  LblAddExisting: "Histórico de pagamentos",
  LblReceiptOrSupport: "Motivo para empresa bloqueada",
  LblManualInvoiceLine: "Manual Invoice Line",
  LblInvoiceLine: "Por favor selecione data de vencimento",
  LblInvoice: "data de vencimento",
  LblInvoiceLines: "Invoice Lines",
  LblSendInvoice: "Enviar fatura",
  LblInvoiceSent: "Invoice Sent",
  LblAddNewInvoiceLine: "Fatura 0% com sucesso",
  LblSelectUnprocessedExpenses: "Select an unprocessed expenses",
  LblSelectAtLeastOneExpense: "Fechado",
  PR_COST_EXPENSES: "Reabrir/ Fechar",
  PR_COST_CENTER_REPORT: "Histórico de pagamentos",
  LblReportedOn: "Reportado em",
  LblInvoicePaymentHistory: "Invoice Payment History",
  LblLogTime: "Hora de registo",
  LblNoPaymentLinkGenerated: "No Payment Link Generated",

  //Payment module
  LblPaymentConfig: "Configuração de pagamento",
  LblPaymentConfigButton: "Configuração de pagamento",
  LblPaymentProvider: "Provedor de pagamento",
  LblCountry: "País",
  LblEmailAddress: "Endereço de e-mail",
  LblInvoicePaymentTermDays: "Histórico de pagamento por data de vencimento",
  LblAllowPaymentConfiguration: "Allow Payment Configuration",
  LblPaymentSetting: "Payment Provider Settings",
  LblAllowPayment: "Allow Payment",
  LblEnvironment: "Ambiente",
  LblLinkValidityDays: "Validade da ligação (dias)",
  LblClosed: "Closed",
  LblConfirmDuedatechange: "Tem a certeza que pretende atualizar a data de vencimento?",
  LblConfirmCloseInvoice: "Tem a certeza que pretende encerrar a fatura?",
  LblConfirmReOpenInvoice: "Tem a certeza que pretende re-abrir a fatura?",
  LblDueDateUpdateSuccess: "Data de vencimento atualizada com sucesso",
  LblDueDateRequiredError: "Please Select Due Date.",
  LblDueDate: "Data de Vencimento",
  LblInvoiceOpenCloseSuccess: "Fatura 0% com sucesso",
  LblPaymentHistory: "Payment History",
  LblPaymentLink: "Payment Link",
  LblPaymentMethods: "Payment Methods",
  LblPaymentMode: "Payment Mode",
  LblPaymentProviderSecretKey: "Senha de acesso do fornecedor",
  LblPaymentProviderUsername: "Nome de utilizador do fornecedor (key)",

  LblCreditCardPayment: "Pagamento com cartão de crédito",
  LblInitialPayment: "Pagamento inicial",
  LblCreateBookingPayment: "Criar pagamento da reserva",
  LblStartBookingPayment: "Iniciar pagamento da reserva",
  LblReasonOrganization: "Motivo para empresa bloqueada",
  LblReOpen: "Reabrir",
  LblReOpenClose: "Reabrir/ Fechar",


  // Error Log
  LblLogType: "Tipo de registo",
  LblErrorLog: "Erro de registo",
  LblComponent: "Componente",
  LblComponentName: "Nome do componente",
  LblEventDateTime: "Data e hora do evento",
  LblMonitoring: "Monitorizar",

  // Interface Status
  LblLastStatusChangeDateTime: "Data/hora da última alteração de estado",
  LblLastCarwisePollDateTime: "Last Carwise Poll DateTime",

  //Booking Type
  LblNORMALBOOKINGTYPE: 'NORMAL',
  LblMAINTENANCEBOOKINGTYPE: 'MANUTENÇÃO',
  LblUNAVAILABLEBOOKINGTYPE: 'INDISPONÍVEL',

  //Booking Request Status
  LblAPPROVEDBOOKINGREQUEST: 'APROVADO',
  LblREJECTEDBOOKINGREQUEST: 'REJEITADO',
  LblPENDINGBOOKINGREQUEST: 'PENDENTE',

  //Booking Status
  LblABORTED: 'ABORTADO',
  LblCANCELLED: 'CANCELADO',
  LblCONFIRMED: 'CONFIRMADO',
  LblFINISHED: 'ACABADO',
  LblNOSHOW: 'NOSHOW',
  LblPENDING: 'PENDENTE',
  LblREVOKED: 'RESCINDIDA',
  LblRUNNING: 'INICIADA',
  LblREADYFORPAYMENT: 'PRONTO PARA PAGAMENTO',

  //Invoice Status
  LblOPEN: 'ABERTA',
  LblSENT: 'ENVIADA',
  LblCLOSED: 'CONCLUÍDO',
  LblREQUESTFORPAYMENT: 'PEDIDO DE PAGAMENTO',
  LblREOPEN: 'REABERTADO',

  //ErrorEscalation
  LblSelectAdminLevel: "Selecionar nível de administrador",
  LblErrorEscalation: "Agravamento de erro",
  LblDuplicateErrorEscalation: "Encontrado erro na duplicação da configuração",
  LblCustomerAdminLevel: "Nível de administrador",
  LblEnableErrorEscalation: "Ativar agravamento de erro",
  LblEnableLogin: "Ativar Registo",
  LblErrorEscalationMinutes: "Minutos para agravamento de erro",
  LblWegoAdminLevel: "Nível administrador WeGo",
  LblInstanceAdminLevel: "Instance Admin Level",

  LblInactiveAfterDays: "Mensagem de utilizador bloqueado",
  LblGdprSettings: "GDPR Settings",

  // Interface Status
  LblInterfaceStatus: "Estado do interface",
  LblUpdatedDateTime: "Atualizar Data/Hora",

  LblMarkDeleteAfterDays: "Mark Delete After (Days)",
  LblNotifyAdminBeforeDays: "Notificar administrador antes de (dias)",
  LblRemovalDate: "Removal Date",
  LblRemovePersonOn: "Excluir utilizador a",

  LblUserBlockMessage: "Mensagem de utilizador bloqueado",
  PR_PAYMENT_HISTORY_LIST: "Payment History",
  PR_BLOCK_UNBLOCK_ORGANIZATION: "Boquear/Desbloquear empresa",
  LblCurrencyConfiguration: "Currency Configuration",
  LblNameSingular: "Nome",
  LblNamePlural: "Name Plural",

  //Special Period
  LblRegularBooking: "Reserva regular",
  LblSpecialRate: "Tarifa especial",
  LblFirstDay: "Primeiro dia",
  LblLastDay: "último dia",
  LblWeekEndContaining: "Fim de semana contém",
  LblSignBeforeAmount: "Símbolo da moeda antes de Montante",
  LblOutOf: "fora de",


  //Credit card payment
  LblCrediCardPayment: "Pagamento com cartão de crédito",
  LblFirstBooking: "Primeira reserva",
  LblAllowRecurringPayment: "Autorizar cartão de crédito",
  LblProceed: "Avançar",
  LblCheckAllowPayment: "Por favor confirme as permissões de pagamentos recurrentes",
  LblPaymentFailed: "Autorizar cartão de crédito",
  LblPaymentSuccess: "Autorização com sucesso",
  LblPaymentFailure: "Autorização sem sucesso",
  LblCompletedSuccess: "O seu autorização foi processado com sucesso",
  LblCompletedFailure:
    "A sua autorização falhou. Por favor tente novamente.",
  LblCreditCardNumber: "Número de cartão de crédito",
  LblCreditCardExpirationDate: "Data de validade cartão de crédito",
  LblCreditCardDetails: "Detalhes Cartão de Crédito",
  LblMakePayment: "Autorizar cartão de crédito",
  LblAdminPaymentConfirmation:
    "Não existe um Autorização ativo ou o pagamento falhou. Quer continuar?",
  LblPaymentDescription:
    "Para poder reservar o veículo, é necessário confirmar a validade do cartão através do pagamento de %0. Adicionalmente, é necessária permissão para dedução do pagamento para futuras reservas. Os pagamentos são processados pelo nosso parceiro Buckaroo. Será reencaminhado para o site do Buckaroo para fazer o pagamento.",
  LblPay: "Pague",
  LblWhenOpeningAppAndRepeat: 'When opening the app for the first time and repeat every',
  LblEveryTimeOpenApp: 'Every time the app is opened',
  'LblWhenMakeBooking': 'When making a booking',
  'LblWhenStartBooking': 'When starting a booking',
  'LblWhenOpenBooking': 'When opening a vehicle',
  'LblSelectContractTypeGroup': 'Quando fechar um grupo de tipo de contrato específico',
  'LblDays': 'Days',
  'LblNewVersion': 'New Version',
  'LblAction': 'Action',
  'LblTAndCName': 'T&C Name',
  'LblOldVersion': 'Old Version',

  LblSureToRevoke: "Tem a certeza que pretende revogar %0?",

  // NIF Number
  LblEnableNIFNumber: "Ativar Número de contribuinte",
  LblNIFNumber: "Número de contribuinte",
  LblAddDriverToOrganization: "Adicionar condutor à organização",
  LblWeGoDefault: "WeGo padrão",
  LblPersonActiveSuccess: "Pessoa ativada com sucesso",
  LblActivate: 'Ativar',
  LblInActiveReason: "InActive Reason",
  LblDefaultLanguage: 'Idioma padrão',
  LblRestoreInheritConfirmation: "As configurações atuais serão substituídas pelas configurações herdadas. Você tem certeza?",
  LblQestionTextRequired: "Texto da pergunta requerido",
  LblManualSecretKey: "Chave secreta",

  // Two Factor Authentication
  LblTwoFaConfig: "Autenticação de dois fatores",
  LblEnableTwoFa: "Ativar autenticação de dois fatores",
  LblExpirationDays: "Dias de expiração",
  LblTextBoxExpirationDays: "Dias de expiração",
  Lbl2FactorAuthenticateExpDays: "2FA expiration period (days):",
  LblResetCookiesWegoAdmin: "Redefinir cookies para todos os administradores do WeGo",
  LblReset2FactorAuthWegoAdmin: "Redefinir todos os 2FA para todos os administradores do WeGo",
  LblAuthentication: "Autenticação",
  LblResetCookiesForAllAdmin: "Redefinir cookies para todos os administradores",
  LblReset2FaForAllAdmin: "Redefinir 2FA para todo administrador",
  LblEnterTotp: "Por favor digite o código",
  LblEnterOtp: "Por favor digite o código",
  LblSubmit: "Enviar",
  LblKeyResetSuccess: "2FA Key foi redefinida",
  LblKeyResetFailed: "Falha na redefinição da chave 2FA",
  LblCookieResetSuccess: "2FA cookies foi redefinido",
  LblCookieResetFailed: "Falha na redefinição dos cookies de 2FA",
  LblGoogleAuthenticator: "Google Authenticator App",
  LblEmailOtpSent: "Um código foi enviado para o seu endereço de e-mail cadastrado",
  LblContinue: "Continuar",
  LblInvalidTOTP: "Código inválido",
  LblResetCookie: "Redefinir Cookie",
  LblResetTwoFA: "Redefinir 2FA",
  LblDisableTwoFA: "Desativar 2FA",
  LblTwoFaMethod: "Método 2FA",
  LblEmailAuthentication: "Autenticação do email",
  LblTwoFaMethodSelect:"Você precisará confirmar sua identidade mais uma vez. Por favor, selecione o seu método 2FA",
  LblInvoicePreFix: "Prefixo do número da fatura",
  LblEngineStillRunning:'Comando de fechamento enviado enquanto o motor está em execução',
  LblMobileAppLink: "Mobile App Link",
  LblFileNotFound:"O arquivo não existe, entre em contato com o helpdesk",

  // License Check Configuration
  LblLicenseCheckConfiguration: "Configuração de verificação de licença",
  LblValidateLicenseCheckForBooking: "Verifique antes de reservar",

  // Access Cards Enabled SVG
  LblAccessCardsEnabled: "Access Card Use",

  // Track & Trace
  LblTrackAndTrace: "Rastrear e rastrear",
  LblRfidTagId: "ID da etiqueta RFID",
  LblEmployeeNumber: "Número de empregado",
  BtnAddVehicleInfo: "Mostra Log de VTS",

  // Access Card
  LblAccessCardId: "Access Card ID",

  LblDriversLicenseAndCertificates: "Driver's license and certificates",
  LblLicense: "Driver's license",
  LblCertificates: "Certificates",

  LblTrips: "Viagens",
  LblCostsSummary: "Costs Summary",
  LblStartBooking: "Start booking",
  LblStopBooking: "Stop booking",

  LblTripHistory: "Histórico de viagem",
  LblTripStartDateTime : "A partir das",
  LblTripEndDateTime: "Às",
  LblFaZTripQuestions: "Perguntas do FaZ",
  LblNoQuestionsFound: "Nenhuma pergunta FaZ encontrada.",
  LblNoTripsFound: "Nenhuma viagem encontrada.",
  LblTripDetails: "Detalhes da viagem",
  LblUnansweredQuestions: "Perguntas não respondidas",
  LblNoUnansweredQuestions: "Nenhuma pergunta sem resposta",
  LblAnswerSaved: "The answer is successfully saved",
  LblAnswerSavedError: "The answer could not be saved. Please contact the Administrator",
  LblAnswerEmptyError: "Please enter a valid answer",

  LblLoginError: "Acconteceu um erro desconhecido ao tentar fazer login.",
  LblLoginCredentialsError: "Este nome de usuário ou senha estão incorretos. Por favor, tente novamente.",

  ValidatePhoneNumberVts: "Por favor introduza um número de telefone fixo válido (Ex.: +31623456789)",
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/translate/lang-pt.ts